import { Box, Button, TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import React, { useState } from "react";
import { SignUpFormProps } from "../types/sign-up-form-types";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from 'react-redux';
import {setMobileNumber} from "../authSlice";
import { sendOtp } from "services/otpService";

interface MobileInputPropTypes {
  openOtpDialog: (number?: string) => void;
  isOtpVerified: boolean;
  formik: FormikProps<SignUpFormProps>
}
const MobileInputField: React.FC<MobileInputPropTypes> = ({openOtpDialog, formik, isOtpVerified}: MobileInputPropTypes) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSendOtp = async () => {
    const mobileNumber = formik.values.mobileNumber;
    if (!mobileNumber || mobileNumber.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }
    setLoading(true);
    try {
      await sendOtp(mobileNumber);
      toast.success("OTP sent successfully!");
      dispatch(setMobileNumber(mobileNumber));
      openOtpDialog();
    } catch (error) {
     toast.error("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputProps = {
    value: formik.values.mobileNumber,
    onChange: formik.handleChange,
    error: formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber),
    helperText: formik.touched.mobileNumber && formik.errors.mobileNumber,
  }

  return (
    <Box>
      <Typography color="text.primary" mb={0.5}>
        Mobile Number*
      </Typography>
      <Box display="flex" columnGap={1} alignItems="center">
        <TextField
          value={inputProps.value}
          onChange={inputProps.onChange}
          name="mobileNumber"
          fullWidth
          placeholder="Enter your mobile number"
          error={inputProps.error}
          helperText={inputProps.helperText}
          slotProps={{
            input: {sx: {bgcolor: "#ffffff"}}
          }}
          
        />
        <Button
        disabled={isOtpVerified}
        onClick={handleSendOtp} disableElevation variant="contained" sx={{fontSize: 12, border: "1px solid #c9c9c9", textTransform: 'capitalize'}}>
           {loading ? "Sending..." : "Send OTP"}
        </Button>
      </Box>
    </Box>
  );
};

export default MobileInputField;
